export default {
	URLS_YOUTUBE_KICHOS: {
		1: {
            url: "https://www.youtube.com/embed/N8Nsl5zW2Ts"
        },
        2: {
            url: "https://www.youtube.com/embed/ViVCrpuDg-w"
        },
        3: {
            url: "https://www.youtube.com/embed/3-ZOBS0FdwI"
        },
        4: {
            url: "https://www.youtube.com/embed/P_nJFCa2A7E"
        },
        5: {
            url: "https://www.youtube.com/embed/Q1OnhoJPBT0"
        },
        6: {
            url: " https://www.youtube.com/embed/Pon7rfnqrj4"
        },
        7: {
            url: "https://www.youtube.com/embed/eH0lzSwNzts"
        }
    },
    URLS_YOUTUBE_OTHER: {
		1: {
            url: "https://www.youtube.com/embed/cSMzSJ4Fln0"
        },
        2: {
            url: "https://www.youtube.com/embed/_APw2IyRNrk"
        },
        3: {
            url: "https://www.youtube.com/embed/pG6xmUO54DQ"
        },
        4: {
            url: "https://www.youtube.com/embed/ZIP_Lb9A4gI"
        },
        5: {
            url: "https://www.youtube.com/embed/oGHMOA4e4gE?si=zqKKgYNLwoIXi-4G"
        },
        6: {
            url: "https://www.youtube.com/embed/V3dZc0UBijg"
        }
    }
}
